export enum AssignmentState {
  empty,
  addWatcher,
  assignResponsible,
  inviteMember,
}
